import ThankYouPage from "@/components/thank-you";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/thank-you")({
  component: RouteComponent,
  validateSearch: z.object({
    email: z.string().email(),
  }),
});

function RouteComponent() {
  const { email } = Route.useSearch();
  return <ThankYouPage email={email} />;
}
